import { render, staticRenderFns } from "./CreateFixedPage.vue?vue&type=template&id=583b2fb3"
import script from "./CreateFixedPage.vue?vue&type=script&lang=js"
export * from "./CreateFixedPage.vue?vue&type=script&lang=js"
import style0 from "./CreateFixedPage.vue?vue&type=style&index=0&id=583b2fb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports